import { render, staticRenderFns } from "./warnRule.vue?vue&type=template&id=4b88a8d5&scoped=true"
import script from "./warnRule.vue?vue&type=script&lang=js"
export * from "./warnRule.vue?vue&type=script&lang=js"
import style0 from "./warnRule.vue?vue&type=style&index=0&id=4b88a8d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88a8d5",
  null
  
)

export default component.exports